import React, { useEffect, useState } from "react";
import {
  SlDrawer,
  SlButton,
} from "@shoelace-style/shoelace/dist/react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function AssignBrand(props) {
  const [salesOptions, setSalesOptions] = useState([]);
  const [assignClicked, setAssignClicked] = useState(false);
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const form1 = useForm();

  const fetchSales  = async() =>{
    try {
      let res = await API({
        url:'/reports/allsalespersons',
        method:'POST',
        responseType:'json',
        data:{}
      })
      if(res.code === 200){
        setSalesOptions(res.data)
      }
    } catch (error) {
      console.error(error)
    }
  }
  const onSubmit = async(data) =>{
    setAssignClicked(true)
    try {
      let res = await API({
        url:'/birdview/assignBrandSales',
        method:'POST',
        responseType:'json',
        data:{
          sales_id:data.sales_id.value,
          brand_id:props.actionId.id,
          // lang_id:data.lang_id.value,
          incentive_rules: data.incentive_rules
        }
      })
      if(res.code === 200){
        Toast('success', "Brand Assigned Sucessfully")
        props.setShow(false)
        props.loadData(props.currentPage)
        props.setActionId()
      }
      else if(res.data.code === 400){
        Toast('error', res.data.message)
      }
    } catch (error) {
      console.error(error)
    }
    finally{
      setAssignClicked(false)
    }
  }
  useEffect(()=>{
    fetchSales()
  }, [])
  return (
    <>
      <SlDrawer
        label="Assign Brand"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          props.setShow(false);
        }}
        style={{ "--size": `${window.innerWidth <= 767 ? '100%' :'30vw'}` }}
      >
        <div>
          <form onSubmit={form1.handleSubmit(onSubmit)}>
            <h6 className="mb-2">{`Assigning brand ${props.actionId.name}`}</h6>
            <div className="mb-3">
              <label className="form-label">Select Sales Person</label>
              <Controller
                name="sales_id" // Name of the form field
                control={form1.control}
                rules={{required:true}}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="sales"
                    placeholder={"Select Sales"}
                    options={salesOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {
                form1.formState.errors.sales_id && <p className="text-red-600">Sales Person is Required!</p>
              }
            </div>
            {/* <div className="mb-3">
              <label className="form-label">Select Language</label>
              <Controller
                name="lang_id" // Name of the form field
                control={form1.control}
                rules={{required:true}}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="language"
                    placeholder={"Select Language"}
                    options={languageOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {
                form1.formState.errors.lang_id && <p className="text-red-600">Language is Required!</p>
              }
            </div> */}
            <div className="mb-3">
              <label className="form-label">Incentive Rules</label>
              <input className="form-control" type="text" placeholder="Enter incentive Rules" {...form1.register('incentive_rules', { required: false })}></input>
            </div>
            <div className="mb-3">
                <SlButton variant="primary" size="small" type="submit" disabled={assignClicked}>
                {assignClicked && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"></span>
                )}
                     {assignClicked ? "Assigning..." :'Assign'}
                </SlButton>
            </div>
          </form>
        </div>
      </SlDrawer>
    </>
  );
}

export default AssignBrand;
